import { useEffect, useState } from "react";

/**
 * Phones, iPhone 13 (390px) first: below a tablet the admin trades the
 * sidebar for a top bar and draws its tables as cards. Keep in sync with the
 * `phone` mixin in src/styles/_media.scss.
 */
export const PHONE_QUERY = "(max-width: 767px)";

const matches = () =>
  typeof window !== "undefined" && window.matchMedia(PHONE_QUERY).matches;

/** True while the window is phone-sized; follows rotation and resizing. */
const useIsPhone = () => {
  const [isPhone, setIsPhone] = useState(matches);

  useEffect(() => {
    const query = window.matchMedia(PHONE_QUERY);
    const onChange = () => setIsPhone(query.matches);
    onChange();
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isPhone;
};

export default useIsPhone;
